












import Vue from "vue";
import {Component} from "vue-property-decorator";
//@ts-ignore
import store from "../../../store";
import {GameAutomation} from "../../../../types";

@Component({
    components: {},
})

/**
 * Компонент состояния стола (время суток) для автоматизации мафии
 */
export default class SimiloInformer extends Vue {
    /**
     * Стейт игры
     * @private
     */
    private get gameAutomation(): GameAutomation|null
    {
        if (!store.getters.getGameState) {
            return null;
        }

        return store.getters.getGameState.automation;
    }

    /**
     * Номер раунда
      * @private
     */
    private get roundNumber(): string|null
    {
        if (!this.gameAutomation || !this.gameAutomation.informers || !this.gameAutomation.informers.round) {
            return null;
        }

        return this.gameAutomation.informers.round.image;
    }

    /**
     * Стейт информера
     * @private
     */
    private get informerState(): string|null
    {
        if (!this.gameAutomation || !this.gameAutomation.informers || !this.gameAutomation.informers.stage) {
            return null;
        }

        return this.gameAutomation.informers.stage.image;
    }

    /**
     * Изображение раунда
     * @private
     */
    private get roundImage(): string
    {
        if (!this.roundNumber) {
            return '';
        }

        return `/images/automations/similo/${this.roundNumber}.png`;
    }

    /**
     * Изображение стадии
     * @private
     */
    private get stageImage(): string
    {
        if (!this.informerState) {
            return '';
        }

        return `/images/automations/similo/${this.informerState}.png`;
    }
}
